import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../apiConfig";
import { resendOTP } from "./otpSlice";

const initialState = {
  isLoading: false,
  logins: null,
  error: null,
  isLoggedIn: false,
  me: null,
  forgotPassword: null,
};

export const postLogin = createAsyncThunk(
  "postLogin/login",
  async ({ data, navigate }, thunkApi) => {
    try {
      const res = await api.post("auth/login", data);

      localStorage.setItem("token", res.data.accessToken);

      if (!res.data.data.verified) {
        navigate("/otp-page");
        toast.info("Your email is not verified yet.");
        thunkApi.dispatch(
          resendOTP({
            email: res.data.data.email,
            user_id: res.data.data.id,
          })
        );
      }

      return {
        data: res.data.data,
        token: res.data.token,
        ...(res.data.data.verified && { navigate }),
      };
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const fetchMe = createAsyncThunk(
  "fetchMe/login",
  async (_, thunkApi) => {
    try {
      const res = await api.get("auth/auth-user", {
        params: {
          populate: "shipping_addresses",
        },
      });

      return res.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const postLogout = createAsyncThunk(
  "postLogout/logout",
  async (data, thunkApi) => {
    try {
      // const res = await api.post("logout", data);
      localStorage.removeItem("token");
      // return res.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const postForgotPassword = createAsyncThunk(
  "postForgotPassword/ForgotPassword",
  async ({ data }, thunkApi) => {
    try {
      const res = await api.post("auth/forgot-password", data);
      return res.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const postResetPassword = createAsyncThunk(
  "postResetPassword/ForgotPassword",
  async ({ data, navigate }, thunkApi) => {
    try {
      const res = await api.post("auth/reset-password", data);
      return { data: res.data.data, navigate };
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const changePassword = createAsyncThunk(
  "changePassword/login",
  async ({ data }, thunkApi) => {
    try {
      const res = await api.post("auth/change-password", data);
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logoutSuccess(state) {
      state.isLoggedIn = false;
      localStorage.removeItem("token");
      localStorage.removeItem("id");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(postLogin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.me = action.payload.data;
      toast.success("Logged in Successfully!");
      if (action.payload.navigate) {
        action.payload.navigate("/");
      }
    });
    builder.addCase(postLogin.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isLoggedIn = false;
      toast.error(JSON.stringify(action.payload.response.data.message));
    });

    builder.addCase(postLogout.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(postLogout.fulfilled, (state, action) => {
      state.isLoading = false;
      window.location.reload();
    });
    builder.addCase(postLogout.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isLoggedIn = false;
      toast.error("Error while loggin out.");
    });

    // TODO: change password
    builder.addCase(changePassword.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.isLoading = false;
      toast.success("Password changed successfully.");
      window.location.reload();
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.isLoading = false;
      toast.error(action.payload.response.data.message);
    });

    // For forgotPassword
    builder.addCase(postForgotPassword.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(postForgotPassword.fulfilled, (state, action) => {
      state.isLoading = false;
      state.forgotPassword = action.payload;
      toast.success("Password reset link is sent to your email.");
    });
    builder.addCase(postForgotPassword.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      toast.error(action.payload.response.data.message);
    });

    // For resetPassword
    builder.addCase(postResetPassword.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(postResetPassword.fulfilled, (state, action) => {
      state.isLoading = false;
      toast.success("Password is changed.");
      action.payload.navigate && action.payload.navigate("/login");
    });
    builder.addCase(postResetPassword.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      toast.error(action.payload.response.data.message);
    });

    builder.addCase(fetchMe.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMe.fulfilled, (state, action) => {
      state.isLoading = false;
      state.me = action.payload;
      state.isLoggedIn = true;
    });
    builder.addCase(fetchMe.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isLoggedIn = false;
      state.me = null;
    });
  },
});

export const { logoutSuccess } = loginSlice.actions;
export default loginSlice.reducer;
